<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                AR Invoice Adjustment - Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Adjustment Number</label></b-input-group-prepend>
                                <b-form-input v-model="model.nomor" readonly></b-form-input>
                            </b-input-group>
                        </b-col>   
                        <b-col lg="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>Adjustment Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" ></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                          <b-form-input  v-model="model.uraian" :state="!$v.model.uraian.nomor"></b-form-input>
                    </b-input-group>
                    <b-row>
                        <b-col lg="6">
                            <b-input-group >
                                <b-input-group-prepend><label>Adjustment Amount</label></b-input-group-prepend>
                                <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                <my-number class="form-control text-right" separator="," v-model="model.nilai" :minus="true" :precision="2" :state="!$v.model.nilai.$error"></my-number>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Adjustment Group</label></b-input-group-prepend>
                                <b-form-select v-model="model.artype" :plain="true" :options="adjustGroups" ></b-form-select>
                            </b-input-group>
                        </b-col>
                    </b-row>
                    <b-input-group >
                        <b-input-group-prepend><label>Destination Account</label></b-input-group-prepend>
                        <b-form-input readonly v-model="model.glAccount"  :state="!$v.model.kodeacc.$error"></b-form-input>
                        <b-input-group-append>
                        <b-btn text="Button" @click="lkuCoaShow=true">
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
                <b-col lg="4">
                    <v-dim :model="model" :key="updateDimHdr"></v-dim>
                </b-col>
              </b-row>   
              <label><strong>Detail Invoice Settlement</strong></label>
              <b-card no-body class="mt-0">
                    <b-table
                        class="mb-0"
                        ref="tblAradjudt"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="aradjudt.items"
                        :fields="aradjudt.fields"
                        :current-page="aradjudt.page"
                        :per-page="aradjudt.limit"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>
                            <template v-slot:cell(nilaibyr)="data">
                            {{data.item.nilaibyr|numFormat}}
                            </template>
                            <template v-slot:cell(kurskeAR)="data">
                            {{data.item.kurskeAR|numFormat('0.000')}}
                            </template>
                            <template v-slot:cell(nilaibank)="data">
                            {{data.item.nilaibank|numFormat}}
                            </template>
                            <template v-slot:cell(kasdiskon)="data">
                            {{data.item.kasdiskon|numFormat}}
                            <div v-if="(data.item.Potongan)">{{data.item.Potongan}}</div>
                            </template>
                            <template v-slot:cell(selisihkurs)="data">
                            {{data.item.selisihkurs|numFormat('0,0.00')}}
                            </template>

                          <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editAradjudt(data.item,data.toggleDetails)">
                              <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delAradjudt(data.index)">
                              <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                      <template v-slot:row-details="row">
                        <b-card no-body class="row-details-form">
                        <b-row align-h="around">
                            <b-col lg="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>AR Invoice No.</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="aradjudtObj.invoiceno" @keyup.13.native="lkuArinvShow=true" :state="!$v.aradjudtObj.arinvKey.$error"></b-form-input>
                                    <b-input-group-append>
                                    <b-btn text="Button" @click="lkuArinvShow=true" >
                                        <i class="fa fa-search"></i>
                                    </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                                    <b-form-input v-model="aradjudtObj.uraian" disabled></b-form-input>
                                </b-input-group>
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label>Total Invoice</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.totalinv" :precision="2" disabled></my-number>
                                        </b-input-group>
                                    </b-col>
                                    <b-col lg="5">
                                        <b-input-group >
                                            <b-input-group-prepend class="d-md-inline d-lg-none"><label>Outstanding</label></b-input-group-prepend>
                                            <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Outstanding</span></b-input-group-prepend>
                                            <b-input-group-prepend class="d-md-block  d-lg-none"><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.outstand" :precision="2" disabled></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters v-if="(aradjudtObj.ttlpph)">
                                    <b-col lg="7">
                                        <b-input-group>
                                            <b-input-group-prepend><label>Potential W/H Tax</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.ttlpph" :precision="2" disabled></my-number>
                                            <b-input-group-prepend><span class="input-group-text">Pasal {{aradjudtObj.pasalpph}}, tarif {{aradjudtObj.pph}}%</span></b-input-group-prepend>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col lg="6">
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Setttled Original Amt.</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.nilaibyr" :minus="true" :precision="2" :state="!$v.aradjudtObj.nilaibyr.$error"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-row no-gutters>
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Setttled LCY Amt.</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{model.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.nilaibank" :minus="true" :precision="2" :state="!$v.aradjudtObj.nilaibank.$error" @keydown.enter.native="handleEnterAmt"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                                <b-input-group >
                                    <b-input-group-prepend><label style="width: 125px !important;">Deduction Original Amt.</label></b-input-group-prepend>
                                    <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                    <my-number class="form-control text-right" v-model="aradjudtObj.kasdiskon" :precision="2" ></my-number>
                                    <b-input-group-prepend class="d-md-inline d-lg-none"><label>Deduction Kind</label></b-input-group-prepend>
                                    <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text"> Deduction Kind</span></b-input-group-prepend>
                                    <b-form-select v-model="aradjudtObj.IDPotongan" :plain="true" :options="potongans" :state="!$v.aradjudtObj.IDPotongan.$error"></b-form-select>
                                </b-input-group>
                                <b-row no-gutters v-if="(model.matauang != aradjudtObj.matauang)">
                                    <b-col lg="7">
                                        <b-input-group >
                                            <b-input-group-prepend><label style="width: 125px !important;">Exch. Rate {{model.matauang}}</label></b-input-group-prepend>
                                            <b-input-group-prepend><span class="input-group-text" style="width:60px;">{{aradjudtObj.matauang}}</span></b-input-group-prepend>
                                            <my-number class="form-control text-right" v-model="aradjudtObj.kurskeAR" :precision="6" :state="!$v.aradjudtObj.kurskeAR.$error"></my-number>
                                        </b-input-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>                            
                            <b-row class="justify-content-center mb-2">
                                <div style="width:400px;">
                                    <b-input-group >
                                        <b-input-group-prepend><span class="p-2">Add Line after update</span></b-input-group-prepend>
                                        <b-form-checkbox v-model="inputLineBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                                        <b-input-group-append>
                                            <b-button class="btn btn-success mr-1" @click="saveAradjudt()">Update</b-button>
                                        </b-input-group-append>
                                        <b-input-group-append>
                                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </b-row>
                        </b-card>
                      </template>                        
                    </b-table>
            <b-row >
                <b-col cols="4">
                    <b-row>
                    <b-button size="sm" class="ml-3" @click="addAradjudt" >Add Settlement</b-button>                          
                        <div class="ml-2">
                            Showing {{((aradjudt.page - 1) * aradjudt.limit + 1)}}
                            to <span v-if="((aradjudt.page * aradjudt.limit)>aradjudt.total)">{{aradjudt.total}}</span>
                                <span v-else>{{aradjudt.page * aradjudt.limit}}</span>
                            <strong> of {{aradjudt.total}} entries </strong>
                        </div>    
                    </b-row>                    
                </b-col>
                <b-col cols="4">          
                    <b-input-group>
                        <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                        <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
                        <b-pagination
                            :total-rows="aradjudt.total"
                            :per-page="aradjudt.limit"
                            v-model="aradjudt.page"
                        ></b-pagination>
                    </b-input-group>
                </b-col>
                <b-col cols="4" >
                    <div class="text-right">
                    <b-input-group >
                        <b-input-group-prepend><label style="width:180px;">Total Detail Settlement</label></b-input-group-prepend>
                        <b-input-group-prepend>
                            <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                        </b-input-group-prepend>
                        <my-number class="form-control text-right" v-model="totalDtlPaym" :precision="2" disabled></my-number>
                    </b-input-group>
                    </div>
                </b-col>        
            </b-row>

            </b-card>    
            <b-row class="justify-content-center mt-1">
                <div style="width:450px;">
                    <b-input-group >
                        <b-input-group-prepend><span class="p-2">remain on Form after save</span></b-input-group-prepend>
                        <b-form-checkbox v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pt-2"></b-form-checkbox>
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>
        </b-card>
        <b-modal v-model="lkuArinvShow" size="lg" :hide-footer="true" title="List of AR Invoice"  :key="model.custcode" :centered="true">
            <lku-arinv @click="onSelectLkuArinv" :formdata="lkuArInvData"></lku-arinv>
        </b-modal>        
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>    
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
.row-details-form {
    label {
    text-align: right !important;;
    }
    legend {
    text-align: right !important;;
    }

}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import lkuArinv from "../lookup/lkuArinvLazzy";
import lkuCoa from "../lookup/lkuCoa";
import dimension from "../../apis/dimension";
import aradjust from '../../apis/aradjust';
import { validationMixin } from "vuelidate";
import { required, minValue } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading,myNumber, vDim, lkuArinv,lkuCoa},
  mixins: [validationMixin],
  validations: {
        model: {
            kodeacc: { required },
            uraian: { required },
            tanggal: { required },
            matauang: { required },
            nilai: { required },
        },
        aradjudtObj :{
            arinvKey: { required },
            nilaibyr: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if (!(this.aradjudtObj.nilaibyr)){
                    return false;
                } else return true;
            }) },
            nilaibank: { minValue:(function() {
                if (this.adaPotongan) {
                    return true;
                } else if (!(this.aradjudtObj.nilaibank)){
                    return false;
                } else return true;
            }) },
            kurskeAR: { required, minValue:minValue(0.0000001) },  
            IDPotongan : { required:(function() {
                if (!this.adaPotongan) {
                    return true;
                } else if ((this.aradjudtObj.IDPotongan || '')==''){
                    return false;
                } else return true;                
            }) },
        },
  }, 
  data() {
    return {
        arGroups : [],
        currency:[{value:'IDR',text:'IDR'}],
        potongans:[],
        saveEnabled:true,
      isLoading:false,
        inputBerlanjut: 1,
        inputLineBerlanjut: 1,
        horizontal:true,
        model:{kurstrx:1},
        lkuCoaShow: false,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        adjustGroups:[],
        aradjudt: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "invoiceno",
                    thStyle: "width:150px",
                    label: "Invoice Number",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibyr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeAR",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Adjustment Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kasdiskon",
                    label: "Settlement in Deduction Amt.",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:80px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },

            ],
            page: 1,
            limit: 20,
            total: 0,
        },
        limit:20,
        aradjudtObj:{arinvKey:'', kodecash:'',IDPotongan:'', kasdiskon:'', nilaibank:'', nilaibyr:''},
        lkuArinvShow: false,
        lkuArInvData:{}
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidAradjudt() {
      this.$v.aradjudtObj.$touch();
      return this.$v.aradjudtObj.$invalid;
    },
    artype(){
        return this.model.artype;
    },
    adaPotongan(){
        return ((this.aradjudtObj.kasdiskon || 0) != 0);
    },
    IDPotongan(){
        return this.aradjudtObj.IDPotongan;
    },
    adaNilaiBank(){
        return ((this.aradjudtObj.nilaibank || 0) != 0);
    },
  },
  watch: {
    artype: function(newval) {
        let grp = this.adjustGroups.find(r => r.value===newval);
        if (grp){
            if (!(this.model.glAccount)) {
                this.model.glAccount = grp.kodeacc.trim() + ' | ' + grp.namaacc.trim();
                this.model.kodeacc = grp.kodeacc;
                this.model.namaacc = grp.namaacc;
            }
        }
    },    
    IDPotongan: function(kode) {
        let pot = this.potongans.find(r => r.value===kode);
        if (pot){
            this.aradjudtObj.Potongan=pot.text;
        }
    },   
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.aradjudt.limit=newVal;
        }
      }, 500);
    },    
  },
  created: async function(){
      this.model.matauang=this.uanguser;
      if (this.$route.params.aradjuttKey) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,b,data] = await Promise.all([aradjust.potongan(),aradjust.aradjustgroup(),aradjust.detail(this.$route.params)]) ;
            this.potongans = a;
            this.adjustGroups = b;

            // const data = await aradjust.detail(this.$route.params);  
            console.log('data : ',data);
            const row = data[0][0];
            this.saveEnabled=(row.posting === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.aradjudt.items = data[1];
            this.aradjudt.total=this.aradjudt.items.length;
            this.calcTotalDtlPaym();
            this.updateDimHdr = !this.updateDimHdr;
            // if (this.model.jenis==='Tunai'){
            //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            // } 
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
            const [a,b] = await Promise.all([aradjust.potongan(),aradjust.aradjustgroup()]) ;
            this.potongans = a;
            this.adjustGroups = b;
      }
  },
  methods: {
    showLkuCoa(callerObj) {
        this.lkuCoaShow=true;
        this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.model.namaacc = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    onSelectLkuArinv(invLookup) {
        this.aradjudtObj.arinvKey=invLookup.selected.arinvKey;
        this.aradjudtObj.invoiceno=invLookup.selected.invoiceno;
        this.aradjudtObj.uraian=invLookup.selected.uraian;
        this.aradjudtObj.matauang=invLookup.selected.matauang;
        this.aradjudtObj.totalinv=invLookup.selected.totalinv;
        this.aradjudtObj.outstand=invLookup.selected.outstand;
        this.aradjudtObj.nilaibyr=invLookup.selected.outstand;
        // this.aradjudtObj.kodecash=invLookup.selected.kodecash;
        this.aradjudtObj.nilaidpp=invLookup.selected.nilaidpp;
        this.aradjudtObj.ttlpph=invLookup.selected.ttlpph;
        this.aradjudtObj.pasalpph=invLookup.selected.pasalpph;
        this.updateDimDtl2Hdr(invLookup.selected);
        if (this.aradjudtObj.matauang.trim() == this.model.matauang.trim()) {
            this.aradjudtObj.nilaibank=invLookup.selected.outstand;
            this.aradjudtObj.kurskeAR = 1;
            this.aradjudtObj.selisihkurs = 0;
        }
      this.lkuArinvShow=false;
      this.lkuArInvData=invLookup;
    },

    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.isLoading=true;            
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.isLoading=false;            
        } else if (Math.abs(this.totalDtlPaym - parseFloat(this.model.nilai))>0.5) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
            this.isLoading=false;            
        } else {
            this.model.TableName = 'aradjutt';
            try {
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.nomor = this.model.nomor || '';
                    this.model.nilai = this.model.nilai || 0;
                      this.model.matauang=this.uanguser;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    let newAradjudts = this.aradjudt.items.reduce((newArr, item) => {
                        if ((item.arinvKey || '') != '') {
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
        
                    this.isLoading=false;
                    row.aradjudt = newAradjudts;
                    const hasil= await aradjust.save(row);
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Adjustment",10000);

                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.isLoading=false;            
                        // const jenis = this.model.jenis;
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        // this.model.jenis = jenis;
                        this.model.matauang= this.$store.state.user.matauang;
                        this.model.tanggal = moment().format('YYYY-MM-DD');
                        this.aradjudt.items = [];
                        this.aradjudt.total=0;
                        this.calcTotalDtlPaym();
                        this.$v.model.$reset();
                    }
                } else {
                    this.isLoading=false;            
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                }
            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.isLoading=false;            
            }

        }
    },
    closeAradjudt: function(){
        const opened= this.aradjudt.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    addAradjudt : function () {
        this.closeAradjudt();
        const obj={_showDetails:true};
        this.aradjudt.selected = obj;
        for (var key in this.aradjudtObj) {
            this.aradjudtObj[key] = '';
        }
        this.aradjudtObj.kurskeAR=1;
        this.aradjudtObj.uraian = this.model.uraian;
        this.tabIndex = 0;
        this.aradjudt.items.push(obj);
        this.aradjudt.total=this.aradjudt.items.length;
        setTimeout(() => {
                const bfore = this.aradjudt.page;
                const after =Math.ceil((this.aradjudt.total)/this.aradjudt.limit);
                if (bfore != after){
                    this.aradjudt.page =  after;                 
                    toastr.info(`Move to page ${after} of total  ${this.aradjudt.total} items`,'Line/Detail',10000);
                }
        }, 100);
        this.inputLineBerlanjut=1;
    },
    editAradjudt : function (obj,callback) {
        this.closeAradjudt();
        this.aradjudt.selected = obj;
        for (var key in this.aradjudtObj) {
            this.aradjudtObj[key] = '';
        }
        for (var key in obj) {
            this.aradjudtObj[key] = obj[key];
        }
        setTimeout(() => {
            this.tabIndex = (this.adaNilaiBank) ? 0:1;            
        }, 200);
        this.inputLineBerlanjut=0;
        callback();
    },
    delAradjudt: function (index) {
        if (index > -1) {
            // this.aradjudt.items.splice(index, 1);
            const posisi = (this.aradjudt.page-1)*this.aradjudt.limit;
            this.aradjudt.items.splice(posisi+index, 1);
        }
        this.aradjudt.total=this.aradjudt.items.length;
        this.calcTotalDtlPaym();
    },
    saveAradjudt: function (callback) {
        if (!this.adaPotongan) this.aradjudtObj.IDPotongan='';
        this.aradjudtObj.nilaibyr = this.aradjudtObj.nilaibyr || 0;
        this.aradjudtObj.kasdiskon = this.aradjudtObj.kasdiskon || 0;
                
        if (this.invalidAradjudt) {
            console.log('validation : ', this.$v.aradjudtObj);
            console.log('model obj : ',this.aradjudtObj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else if (this.aradjudtObj.nilaibyr>this.aradjudtObj.outstand){
            toastr.error('Receipt Amount exceeds Outstanding Amount', "ERROR MESSAGE");
       } else {
            let totInvSttl = this.aradjudt.items.reduce((tot, item) => {
                            if (item.arinvKey == this.aradjudtObj.arinvKey) {
                                tot + ((item.nilaibyr||0)+(item.kasdiskon||0));
                            }
                            return tot;
                        }, (this.aradjudtObj.nilaibyr + this.aradjudtObj.kasdiskon));
            if (this.aradjudt.selected.arinvKey == this.aradjudtObj.arinvKey)
                totInvSttl= totInvSttl -  ((this.aradjudt.selected.nilaibyr||0) + (this.aradjudt.selected.kasdiskon||0));

            // if ((this.aradjudtObj.nilaibyr + this.aradjudtObj.kasdiskon)>this.aradjudtObj.outstand){
            if (totInvSttl>this.aradjudtObj.outstand){
                toastr.error('Settled Amount exceeds Outstanding Amount', "ERROR MESSAGE");
            } else {
                this.aradjudtObj.selisihkurs = this.aradjudtObj.nilaibank - (this.aradjudtObj.nilaibyr * this.aradjudtObj.kurskeAR);
                for (var key in this.aradjudtObj) {
                    this.aradjudt.selected[key] = this.aradjudtObj[key];
                }
                this.calcTotalDtlPaym();
                this.aradjudt.selected._showDetails=false;
                if (callback) callback();
                if (this.inputLineBerlanjut==1) {
                    this.addAradjudt();
                    this.$v.aradjudtObj.$reset();
                }

            }

        }
    },
    handleEnterAmt: function (e) {
      // handle CTRL+ENTER , mengisi otomatis DB atau CREDIT, senilai selisih
      if (e.ctrlKey) {
          this.aradjudtObj.nilaibank= this.model.nilai-this.totalDtlPaym;
          if (this.model.matauang == this.aradjudtObj.matauang) {
              this.aradjudtObj.nilaibyr=this.aradjudtObj.nilaibank;
          } 
      }  
    },

    calcPotongan : function() {
        let pot = this.potongans.find(r => r.value=== this.aradjudtObj.IDPotongan);
        if (pot){
            if (pot.pajak) {
                this.aradjudtObj.kasdiskon = this.aradjudtObj.nilaidpp * this.aradjudtObj.tarif / 100;
            } else {
                this.aradjudtObj.kasdiskon = this.aradjudtObj.totalinv * this.aradjudtObj.tarif / 100;
            }
        } else {
            this.aradjudtObj.kasdiskon = this.aradjudtObj.totalinv * this.aradjudtObj.tarif / 100;
        }
    },
    onSelectLkuCoa(_selected) {
        this.model.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        this.model.kodeacc = _selected.kodeacc;
        this.lkuCoaShow=false;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },

    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        totalDtlPaym = totalDtlPaym || 0;
        this.aradjudt.items.forEach((trx)=> {
            if (trx.arinvKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    close(){
      if ((this.$store.state.prevRoute.name)  && (this.$store.state.prevRoute.name=='receivable.invadjustfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'receivable.invadjust'});
      }
    }
  }
};
</script>
